/* eslint-disable no-undef */
import { getTokenFromStorage } from '../storage/get_token'

// 项目
const RAP = process.env.REACT_APP_PROJECT
// 环境(dev,test,prod)
const DEP_ENV = process.env.REACT_APP_DEP
const isEnvExist = ['dev', 'test', 'prod'].includes(DEP_ENV)

// 类似/apps/$appId/res/95?token=$token'形式的路径参数值替换
export const transUrl = (url, appId) => {
  if (!url) return null

  let finalUrl = url

  if (appId) {
    finalUrl = url.replace('$appId', appId)
  }

  finalUrl = finalUrl.replace('$token', getTokenFromStorage())
  finalUrl = finalUrl.replace('$key', RAP)
  finalUrl = finalUrl.replace('$cpkey', `/cp/${RAP}`)
  return finalUrl
}

// 判断是否是当前项目，是否需要切换项目
const isReverseNav = (nav) => {
  // console.log('RAP', RAP, nav)
  if (RAP && nav.project) {
    // 切换项目
    // FIXME: 有导航编辑器之后修改project
    if (nav.project === 'web') {
      return false
    }
    return RAP !== nav.project
  }
  return false
}

export const reverseNav = (nav) => {
  const { projects } = (voltaliStore && voltaliStore.config) || {}
  // 先判断环境
  if (!isEnvExist && !projects) {
    return nav.url
  }

  // const env = projects[DEP_ENV]
  // const project = env[nav.project]
  const project = projects[nav.project]
  if (!project) {
    return nav.url
  }

  if (DEP_ENV === 'dev' && project.port) {
    return `//${document.location.hostname}:${project.port}${nav.url}`
  }
  if ((DEP_ENV === 'test' || DEP_ENV === 'prod') && project.port) {
    return `//${project.domain}${nav.url}`
  }
  return nav.url
}

// 路径跳转方式
/* eslint-disable no-unused-expressions */
export const UrlJumpMode = (nav = {}, appId) => {
  const url = transUrl(nav.url, appId)
  const isReverse = isReverseNav(nav)
  console.log(`${nav.navType} to:`, url, process.env, `isReverse: ${isReverse}`)
  // console.log(isReverse)
  if (nav.navType === 'push') {
    if (isReverse) {
      return { navType: 'href', url: transUrl(reverseNav(nav), appId) }
    }
    return { navType: 'push', url }
  }
  if (nav.navType === 'replace') {
    if (isReverse) {
      return { navType: 'href', url: transUrl(reverseNav(nav), appId) }
    }
    return { navType: 'replace', url }
  }
  if (nav.navType === 'refresh') {
    if (isReverse) {
      return { navType: 'push', url }
    }
    return { navType: 'href', url }
  }
  if (nav.navType === 'open') {
    if (nav.project && isReverse) {
      return { navType: 'open', url: transUrl(reverseNav(nav), appId) }
    }
    return { navType: 'open', url }
  }
  return {}
}

export const routeTo = (url, appId, navigate) => {
  console.warn("请不要再使用 routeTo 使用 use route 的 hooks")
  if (typeof url === 'object') {
    const obj = UrlJumpMode(url, appId)
    const { navType } = obj
    console.log('[route-to] --->', obj)
    if (obj.url) {
      if (navType === 'push' && navigate) {
        // history.push(obj.url)
        navigate(obj.url)
      } else if (navType === 'replace' && navigate) {
        // history.replace(obj.url)
        navigate(obj.url, { replace: true })
      } else if (navType === 'href') {
        window.location.href = obj.url
      } else if (navType === 'open') {
        window.open(obj.url)
      } else {
        window.location.href = obj.url
      }
    }
  } else {
    window.location.href = url
  }
}
